import React, { useState } from 'react';
import ProactiveAgent from '../images/proactiveagent.png';
import liveTyping from '../images/livetyping.png';
import mrpwImage from '../images/mrpw.png';
import novelty from '../images/novelty.png';
import pace from '../images/pace.png';
import grace from '../images/grace.png';
import { FaFilePdf, FaPaperclip, FaFileCode, FaCarrot, FaAward, FaDatabase, FaCode} from "react-icons/fa";
import { Helmet } from 'react-helmet';

const Publications = () => {
  const [isMerged, setIsMerged] = useState(false);
  const handleVennClick = () => setIsMerged(!isMerged);

  // Keyboard toggle for Venn (no visual change)
  const handleVennKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setIsMerged((v) => !v);
    }
  };

  return (
    <div
      role="main"
      aria-labelledby="pubs-title"
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        margin: '0 auto',
        maxWidth: '800px',
        padding: '0 20px',
        fontFamily: 'Nunito Sans, sans-serif',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        backgroundColor: 'white',
        minHeight: '80vh',
        marginTop: '30px',
      }}
    >
      <Helmet>
        <meta name="robots" content="nosnippet" />
      </Helmet>

      <style>
        {`
          .sr-only {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            white-space: nowrap;
            border: 0;
            user-select: none;
            -webkit-user-select: none;
            pointer-events: none;
            -webkit-touch-callout: none;
          }

          .links-visual{list-style:none;padding-left:0;margin:6px 0}
          .links-visual li{display:inline-block;margin-right:6px;margin-bottom:6px}

          .reader-inline{
            height:0;overflow:hidden;margin:0;font-size:0;line-height:0;
            user-select:none;-webkit-user-select:none;pointer-events:none;-webkit-touch-callout:none;
            contain: content;
          }

          .footnote-ui::before{
            content:"* Equal Contribution";
            color:#7C7C7C;
          }

          @media (min-width:768px){
            div.container{display:flex;align-items:flex-start;justify-content:flex-start;text-align:left}
            div.container img{height:150px;margin-right:10px;border-radius:16px}
          }

          .coral-link{color:#e85d4e;text-decoration:none;transition:color .3s}
          .coral-link:hover,.coral-link:active{color:#7C7C7C}
          .author-link{color:#7C7C7C;text-decoration:none;transition:color .3s}
          .author-link:hover,.author-link:active{color:#e85d4e}
          .name{color:#a3b759}
          .bubble-link{background:#F3F3F3;border-radius:8px;padding:8px 10px;margin:0 5px;display:inline-block;line-height:.5}

          .tooltip{position:relative;display:inline-block;cursor:pointer}
          .tooltip .tooltiptext{
            display:none;width:200px;background:#fff;color:#7C7C7C;text-align:center;border-radius:6px;
            padding:5px 10px;position:absolute;z-index:1;bottom:125%;left:50%;margin-left:-100px;
            box-shadow:0 0 6px rgba(0,0,0,.2);font-size:10px
          }
          .tooltip:hover .tooltiptext,
          .tooltip:focus-within .tooltiptext{display:block}

          .venn-container{position:relative;width:300px;height:300px;margin:auto;cursor:pointer}
          .circle{position:absolute;width:180px;height:180px;border-radius:50%;transition:transform 1s}
          .circle-top{background:rgba(117,122,98,.2);top:5%;left:20%;transform:translateX(5%) translateY(0%);border:1px solid #757A62}
          .circle-left{background:rgba(225,192,197,.2);bottom:0;left:20%;transform:translateX(-25%) translateY(0%);border:1px solid #E1C0C5}
          .circle-right{background:rgba(236,193,124,.2);bottom:0;right:15%;transform:translateX(25%) translateY(0%);border:1px solid #ECC17C}
          .venn-container:hover .circle-top{transform:translateX(5%) translateY(25%)}
          .venn-container:hover .circle-left{transform:translateX(0%) translateY(-25%)}
          .venn-container:hover .circle-right{transform:translateX(0%) translateY(-25%)}

          .text-left{position:absolute;bottom:20px;left:50px;color:#E1C0C5;text-align:center;line-height:1.1}
          .text-right{position:absolute;bottom:35px;right:50px;color:#ECC17C;text-align:center;line-height:1.1}
          .text-top{position:absolute;top:45px;left:50%;transform:translateX(-38%);color:#757A62;text-align:center;line-height:1.1}

          .research-interests{position:absolute;top:0;right:0;padding-left:20px;width:calc(100% - 300px);height:100%;display:flex;align-items:center;font-size:11px;color:#7C7C7C}

          @media (orientation:landscape){.tooltip .author-link{font-size:16px}}
        `}
      </style>

      <div id="pubs-title" role="heading" aria-level="1" className="sr-only" inert>
        Publications Section
      </div>

      <div
        role="heading"
        aria-level="2"
        style={{
          fontSize: '16px',
          color: '#7C7C7C',
          lineHeight: '1.4',
          marginTop: '1vh',
          marginBottom: '30px',
          fontWeight: 'bold'
        }}
      >
        Conference Proceedings
      </div>
{/* C4 */}
<div
  className="container"
  role="article"
  aria-labelledby="paper2-title"
  style={{
    marginBottom: '30px',
    display: 'flex',
    alignItems: 'flex-start'
  }}
>
  <img
    src={pace}
    alt="Overview of the Prompt and Circumstance accessibility benchmark study"
    style={{ height: '150px', borderRadius: '0px' }}
  />

  <div
    style={{
      fontSize: '16px',
      color: '#7C7C7C',
      lineHeight: '1.4',
      marginTop: '1vh',
      marginLeft: '10px',
      textAlign: 'left'
    }}
  >
    <div
      id="paper2-title"
      role="heading"
      aria-level="3"
      style={{
        marginBottom: '5px',
        fontWeight: 'inherit'
      }}
    >
      <strong>
        Prompt and Circumstance: Evaluating Accessibility in LLM-Generated HTML Form Components
      </strong>
    </div>

    <div style={{ marginBottom: '5px' }}>
      <span className="name">Yumeng Ma</span>,{' '}

      <span className="tooltip">
        <a
          href="https://faculty.washington.edu/wobbrock/"
          target="_self"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', fontSize: '16px' }}
          className="author-link"
        >
          Jacob O. Wobbrock
        </a>
        <span className="tooltiptext" aria-hidden="true">
          Professor of Information and, by courtesy, Computer Science & Engineering at the University of Washington
        </span>
      </span>,{' '}

      <span className="tooltip">
        <a
          href="https://accessibility.day/about/"
          target="_self"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', fontSize: '16px' }}
          className="author-link"
        >
          Joe Devon
        </a>
        <span className="tooltiptext" aria-hidden="true">
          Founder of A11y Audits and co-founder of Global Accessibility Awareness Day
        </span>
      </span>,{' '}

      <span className="tooltip">
        <a
          href="https://aaron-gustafson.com/"
          target="_self"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', fontSize: '16px' }}
          className="author-link"
        >
          Aaron Gustafson
        </a>
        <span className="tooltiptext" aria-hidden="true">
          Principal Accessibility Innovation Strategist at Microsoft
        </span>
      </span>,{' '}

      <span className="tooltip">
        <a
          href="https://github.com/mfairchild365"
          target="_self"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', fontSize: '16px' }}
          className="author-link"
        >
          Michael Fairchild
        </a>
        <span className="tooltiptext" aria-hidden="true">
          Former Technical Program Manager for Accessibility at Microsoft
        </span>
      </span>,{' '}

      <span className="tooltip">
        <a
          href="https://make4all.org/portfolio/jennifer-mankoff/"
          target="_self"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', fontSize: '16px' }}
          className="author-link"
        >
          Jennifer Mankoff
        </a>
        <span className="tooltiptext" aria-hidden="true">
          Director of the Center for Research and Education on Accessible Technology and Experiences and Professor at the University of Washington
        </span>
      </span>, and{' '}

      <span className="tooltip">
        <a
          href="https://venkateshpotluri.me/"
          target="_self"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', fontSize: '16px' }}
          className="author-link"
        >
          Venkatesh Potluri
        </a>
        <span className="tooltiptext" aria-hidden="true">
          Assistant Professor at the School of Information, University of Michigan
        </span>
      </span>
    </div>

    <div style={{ marginBottom: '5px' }}>
      <span style={{ fontWeight: '500', color: '#676767' }}>
        ASSETS 2026
      </span>
    </div>

    <ul
      className="links-visual"
      role="list"
      aria-label="Resources"
    >
      <li>
        <a
          href="../documents/pace.pdf"
          className="coral-link bubble-link"
          aria-label="PDF for Prompt and Circumstance paper"
        >
          preprint <FaFilePdf size={10} aria-hidden="true" />
        </a>
      </li>

      <li>
        <a
          href="https://github.com/momentine/pace"
          className="coral-link bubble-link"
          aria-label="GitHub repository for PACE"
        >
          code <FaFileCode size={10} aria-hidden="true" />
        </a>
      </li>

      <li>
        <a
          href="https://doi.org/10.5281/zenodo.21303068"
          className="coral-link bubble-link"
          aria-label="Dataset for Prompt and Circumstance"
        >
          dataset <FaDatabase size={10} aria-hidden="true" />
        </a>
      </li>
    </ul>
  </div>
</div>

      {/* C3 */}
      <div className="container" role="article" aria-labelledby="paper1-title" style={{ marginBottom: '30px', display: 'flex', alignItems: 'flex-start' }}>
        <img src={novelty} alt="Counterbalanced order of how the novelty bias study is set up" style={{ height: '150px', borderRadius: '16px' }} />
        <div style={{ fontSize: '16px', color: '#7C7C7C', lineHeight: '1.4', marginTop: '1vh', marginLeft: '10px', textAlign: 'left' }}>
          <div id="paper1-title" role="heading" aria-level="3" style={{ marginBottom: '5px', fontWeight: 'inherit' }}>
            <strong>Quantifying the Novelty Bias When Evaluating Interactive Prototypes</strong>
          </div>

          <div style={{ marginBottom: '5px' }}>
             <span className="name">Yumeng Ma</span>, {' '}
            <span className="tooltip">
              <a href="https://www.alexishiniker.com/" target="_self" rel="noopener noreferrer" style={{ textDecoration: 'none', fontSize: '16px' }} className="author-link">Alexis Hiniker</a>
              <span className="tooltiptext" aria-hidden="true">Associate Professor in the Informatioin School at University of Washington </span>
            </span>, and{' '}
            <span className="tooltip">
              <a href="https://faculty.washington.edu/wobbrock/" target="_self" rel="noopener noreferrer" style={{ textDecoration: 'none' }} className="author-link">Jacob O. Wobbrock</a>
              <span className="tooltiptext" aria-hidden="true">Professor of Information and, by courtesy, Computer Science & Engineering at the University of Washington</span>
            </span>
          </div>

          <div style={{ marginBottom: '5px' }}>
            <span style={{ fontWeight: '500', color: '#676767' }}>CHI 2026</span>
          </div>
          {/* <div style={{ marginBottom: '5px' }}>
              <FaAward size={12} aria-hidden="true" /> Best Paper Honorable Mention Award
          </div> */}
          <div style={{ marginBottom: '5px' }}>
  <FaAward size={12} color="#E1C0C5" aria-hidden="true" /> Best Paper Honorable Mention Award
</div>

          <ul className="links-visual" role="list" aria-label="Resources">
            <li>
              <a
                href="../documents/novelty.pdf"
                className="coral-link bubble-link"
                aria-label="PDF for novelty paper"
              >
                pdf <FaFilePdf size={10} aria-hidden="true" />
              </a>
            </li>
                     <li>
              <a
                href="https://dl.acm.org/doi/full/10.1145/3772318.3791685"
                className="coral-link bubble-link"
                aria-label="webpage for live typing paper"
              >
                paper <FaPaperclip size={10} aria-hidden="true" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      
      {/* C2 */}
      <div className="container" role="article" aria-labelledby="paper1-title" style={{ marginBottom: '30px', display: 'flex', alignItems: 'flex-start' }}>
        <img src={liveTyping} alt="Chat UI mockups showing live typing indicators" style={{ height: '150px', borderRadius: '16px' }} />
        <div style={{ fontSize: '16px', color: '#7C7C7C', lineHeight: '1.4', marginTop: '1vh', marginLeft: '10px', textAlign: 'left' }}>
          <div id="paper1-title" role="heading" aria-level="3" style={{ marginBottom: '5px', fontWeight: 'inherit' }}>
            <strong>“Together but not together”: Evaluating Typing Indicators for Interaction-Rich Communication</strong>
          </div>

          <div style={{ marginBottom: '5px' }}>
            <span className="tooltip">
              <a href="https://zainabiftikhar.com/" target="_self" rel="noopener noreferrer" style={{ textDecoration: 'none', fontSize: '16px' }} className="author-link">Zainab Iftikhar</a>
              <span className="tooltiptext" aria-hidden="true"> Ph.D. Candidate at Brown University</span>
            </span>, <span className="name">Yumeng Ma</span>, and{' '}
            <span className="tooltip">
              <a href="https://jeffhuang.com/" target="_self" rel="noopener noreferrer" style={{ textDecoration: 'none' }} className="author-link">Jeff Huang</a>
              <span className="tooltiptext" aria-hidden="true"> Associate Professor and Associate Chair of Computer Science at Brown University</span>
            </span>
          </div>

          <div style={{ marginBottom: '5px' }}>
            <span style={{ fontWeight: '500', color: '#676767' }}>CHI 2023</span>
          </div>

          <ul className="links-visual" role="list" aria-label="Resources">
            <li>
              <a
                href="../documents/live_typing.pdf"
                className="coral-link bubble-link"
                aria-label="PDF for live typing paper"
              >
                pdf <FaFilePdf size={10} aria-hidden="true" />
              </a>
            </li>
            <li>
              <a
                href="https://doi.org/10.1145/3544548.3581248"
                className="coral-link bubble-link"
                aria-label="webpage for live typing paper"
              >
                paper <FaPaperclip size={10} aria-hidden="true" />
              </a>
            </li>
            <li>
              <a
                href="https://github.com/brownhci/live-typing"
                className="coral-link bubble-link"
                aria-label="Code repository for live typing paper"
              >
                code <FaFileCode size={10} aria-hidden="true" />
              </a>
            </li>
          </ul>

          <p className="reader-inline" aria-hidden="true" inert>
            Resources: <a href="../documents/live_typing.pdf">PDF</a> · <a href="https://doi.org/10.1145/3544548.3581248">Paper</a> · <a href="https://github.com/brownhci/live-typing">Code</a>
          </p>
        </div>
      </div>

      {/* C1 */}
      <div className="container" role="article" aria-labelledby="paper2-title" style={{ marginBottom: '30px', display: 'flex', alignItems: 'flex-start' }}>
        <img src={mrpwImage} alt="Illustration of a laptop-based videoconferencing setup showing how users appear during a call." style={{ height: '150px', borderRadius: '16px' }} />
        <div style={{ fontSize: '16px', color: '#7C7C7C', lineHeight: '1.4', marginTop: '1vh', marginLeft: '10px', textAlign: 'left' }}>
          <div id="paper2-title" role="heading" aria-level="3" style={{ marginBottom: '5px', fontWeight: 'inherit' }}>
            <strong>The Mixed Reality Passthrough Window: Rethinking the Laptop Videoconferencing Experience</strong>
          </div>

          <div style={{ marginBottom: '5px' }}>
            <span className="tooltip">
              <a href="https://www.gonsherdesign.com/" target="_self" rel="noopener noreferrer" style={{ textDecoration: 'none' }} className="author-link">Ian Gonsher</a>
              <span className="tooltiptext" aria-hidden="true"> Assistant Professor in the School of Engineering and Department of Computer Science at Brown University</span>
            </span>, <span className="name">Yumeng Ma</span>, Ivan Pineda-Dominguez, Matthew Lee, and{' '}
            <span className="tooltip">
              <a href="https://www.linkedin.com/in/horatiohan/" target="_self" rel="noopener noreferrer" style={{ textDecoration: 'none' }} className="author-link">Yuxin Han</a>
              <span className="tooltiptext" aria-hidden="true"> Senior Industrial Designer at Superpedestrian</span>
            </span>
          </div>

          <div style={{ marginBottom: '5px' }}>
            <span style={{ fontWeight: '500', color: '#676767' }}>IHIET-AI 2023</span>
          </div>

          <ul className="links-visual" role="list" aria-label="Resources">
            <li>
              <a
                href="../documents/mrpw.pdf"
                className="coral-link bubble-link"
                aria-label="PDF for mixed reality window paper"
              >
                pdf <FaFilePdf size={10} aria-hidden="true" />
              </a>
            </li>
            <li>
              <a
                href="http://doi.org/10.54941/ahfe1002954"
                className="coral-link bubble-link"
                aria-label="webpage for mixed reality window paper"
              >
                paper <FaPaperclip size={10} aria-hidden="true" />
              </a>
            </li>
          </ul>

          <p className="reader-inline" aria-hidden="true" inert>
            Resources: <a href="../documents/mrpw.pdf">PDF</a> · <a href="http://doi.org/10.54941/ahfe1002954">Paper</a>
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '10px' }} />

      <div
        role="heading"
        aria-level="2"
        style={{
          fontSize: '16px',
          color: '#7C7C7C',
          lineHeight: '1.4',
          marginTop: '1vh',
          marginBottom: '30px',
          fontWeight: 'bold'
        }}
      >
        Extended Abstracts
      </div>

      {/* A2 */}
      <div className="container" role="article" aria-labelledby="paper3-title" style={{ marginBottom: '60px', display: 'flex', alignItems: 'flex-start' }}>
        <img
          src={grace}
          alt="tbd"
          style={{ height: '150px', borderRadius: '16px' }}
        />
        <div style={{ fontSize: '16px', color: '#7C7C7C', lineHeight: '1.4', marginTop: '1vh', marginLeft: '10px', textAlign: 'left' }}>
          <div id="paper3-title" role="heading" aria-level="3" style={{ marginBottom: '5px', fontWeight: 'inherit' }}>
            <strong>Designing Graceful Degradation for Multimodal Autonomous Vehicle Cabins</strong>
          </div>

          <div style={{ marginBottom: '5px' }}>
            <span className="name">Yumeng Ma</span>
            {' '}and{' '}
            <span className="tooltip">
              <a
                href="https://www.linkedin.com/in/jiahao-ren-b912b2b3/"
                target="_self"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
                className="author-link"
              >
                Rani Malhotra
              </a>
              <span className="tooltiptext" aria-hidden="true">Lead consultant for the Applied Research Center for Autonomous Machines at the Infosys Center for Emerging Technology Solutions</span>
            </span>
          </div>

          <div style={{ marginBottom: '5px' }}>
            <span style={{ fontWeight: '500', color: '#676767' }}>AutoUI 2026 Adjunct</span>
          </div>

          <ul className="links-visual" role="list" aria-label="Resources">
            <li>
              <a
                href="../documents/grace.pdf"
                className="coral-link bubble-link"
                aria-label="PDF for Graceful Degradation paper"
              >
                pdf <FaFilePdf size={10} aria-hidden="true" />
              </a>
            </li>
            <li>
              <a
                href="https://dl.acm.org/doi/10.1145/3828158.3838226"
                className="coral-link bubble-link"
                aria-label="webpage for Graceful Degradation paper"
              >
                paper <FaPaperclip size={10} aria-hidden="true" />
              </a>
            </li>
          </ul>

          <p className="reader-inline" aria-hidden="true" inert>
            Resources: <a href="../documents/grace.pdf">PDF</a> · <a href="https://dl.acm.org/doi/10.1145/3828158.3838226">Paper</a>
          </p>
        </div>
      </div>
      

      {/* A1 */}
      <div className="container" role="article" aria-labelledby="paper3-title" style={{ marginBottom: '60px', display: 'flex', alignItems: 'flex-start' }}>
        <img
          src={ProactiveAgent}
          alt="Diagram of a proactive reminder system using spoken input, visual context, long- and short-term memory, and generated output"
          style={{ height: '150px', borderRadius: '16px' }}
        />
        <div style={{ fontSize: '16px', color: '#7C7C7C', lineHeight: '1.4', marginTop: '1vh', marginLeft: '10px', textAlign: 'left' }}>
          <div id="paper3-title" role="heading" aria-level="3" style={{ marginBottom: '5px', fontWeight: 'inherit' }}>
            <strong>ProactiveAgent: Personalized Context-Aware Reminder System</strong>
          </div>

          <div style={{ marginBottom: '5px' }}>
            <span className="name">Yumeng Ma</span>
            <sup role="note" aria-label="equal contribution">*</sup>
            {' '}and{' '}
            <span className="tooltip">
              <a
                href="https://www.linkedin.com/in/jiahao-ren-b912b2b3/"
                target="_self"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
                className="author-link"
              >
                Jiahao Ren
              </a>
              <span className="tooltiptext" aria-hidden="true"> Software Engineer at Magic Leap</span>
            </span>
            <sup role="note" aria-label="equal contribution">*</sup>
          </div>

          <div style={{ marginBottom: '5px' }}>
            <span style={{ fontWeight: '500', color: '#676767' }}>UIST 2023 Adjunct</span>
          </div>

          <ul className="links-visual" role="list" aria-label="Resources">
            <li>
              <a
                href="../documents/ProactiveAgent.pdf"
                className="coral-link bubble-link"
                aria-label="PDF for ProactiveAgent paper"
              >
                pdf <FaFilePdf size={10} aria-hidden="true" />
              </a>
            </li>
            <li>
              <a
                href="https://dl.acm.org/doi/10.1145/3586182.3625115"
                className="coral-link bubble-link"
                aria-label="webpage for ProactiveAgent paper"
              >
                paper <FaPaperclip size={10} aria-hidden="true" />
              </a>
            </li>
          </ul>

          <p className="reader-inline" aria-hidden="true" inert>
            Resources: <a href="../documents/ProactiveAgent.pdf">PDF</a> · <a href="https://dl.acm.org/doi/10.1145/3586182.3625115">Paper</a>
          </p>
        </div>
      </div>

      {/* Visible footnote text (read by SRs) */}
      <div
        id="equal-contribution-note"
        aria-label="asterisk denotes equal contribution"
        style={{
          position: 'relative',
          bottom: '50px',
          left: '20px',
          fontSize: '12px',
          color: '#7C7C7C',
          textAlign: 'left',
          marginTop: '30px',
          marginBottom: '30px'
        }}
      >
    
        <span
  role="img"
  aria-label="asterisk denotes equal contribution"
  title="Asterisk denotes equal contribution"
  style={{ display: 'inline-flex', alignItems: 'center' }}
>
  *
</span>{' '}
denotes equal contribution

      </div>


      {/* Curiosity / Venn */}
      <div
        style={{
          position: 'relative',
          bottom: '50px',
          fontSize: '12px',
          textAlign: 'center',
          marginTop: '0px',
          marginBottom: '30px'
        }}
      >
        <div
          className="venn-container"
          onClick={handleVennClick}
          onKeyDown={handleVennKeyDown}
          role="button"
          tabIndex={0}
          aria-pressed={isMerged}
          aria-label="Venn diagram of my research interests."
        >
          <div className={`circle circle-left ${isMerged ? 'merge' : ''}`}></div>
          <span className="text-left">system design <br />&amp; evaluation<br /></span>

          <div className={`circle circle-right ${isMerged ? 'merge' : ''}`}></div>
          <span className="text-right">accessibility</span>

          <div className={`circle circle-top ${isMerged ? 'merge' : ''}`}></div>
          <span className="text-top">human-ai interaction</span>
        </div>

        <div className="research-interests" aria-hidden="false">
          <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
            <span style={{ marginLeft: '8px' }}>
              what I’m curious about{' '}
              <span
                role="img"
                aria-label="carrot icon"
                title="Carrot icon"
                style={{ display: 'inline-flex', alignItems: 'center' }}
              >
                <FaCarrot size={12} color="#7C7C7C" aria-hidden="true" />
              </span>
            </span>
          </div>
        </div>

        <p className="reader-inline" aria-hidden="true" inert>
          What I’m curious about: systems design & evaluation · accessibility · human–AI interaction
        </p>
      </div>

      {/* Watermark */}
      <div
        className="copy-right"
        style={{
          fontSize: '12px',
          color: '#7C7C7C',
          textAlign: 'center',
          marginTop: '20px',
          position: 'absolute',
          bottom: '10px',
          width: '100%',
          borderTop: '1px solid white',
          marginBottom: '10px',
          zIndex: '20',
        }}
      >
        Potayto Workshop by Yumeng Ma
      </div>
    </div>
  );
};

export default Publications;
